import React, { Component } from 'react'
import ReactHtmlParser from 'react-html-parser'
import Header from './../Layouts/Header';
import Content from './../Layouts/Content';
import Sidebar from './../Layouts/Sidebar';
import Footer from './../Layouts/Footer';
import API from './../Function/APILink'
import queryString from 'query-string'
import { connect } from 'react-redux'
import Preload from '../Layouts/Preload';
import GoTop from '../Function/GoTop';

export class Result extends Component {

    constructor(props){
        super(props)

        this.componentWillMount = this.componentWillMount.bind(this)
        this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this)
        this.componentDidMount = this.componentDidMount.bind(this)
        this.state = {
            keyword: "",
            sort: "",
            levelcat: '0',
            category: "",
            category2: "",
            category3: "",
            page: 1,
            correctkeyword: '',
            relatedtaglist: [],
            token: 'qwertygf123456',
            preloader: true
        }
    }

    componentWillMount() {
        // URL Paramaters
        const urlparameter = queryString.parse(this.props.location.search)
        this.setState({
            keyword: (urlparameter.keyword) ? urlparameter.keyword : '',
            sort: (urlparameter.sort) ? urlparameter.sort : 'terkait',
            page: (urlparameter.page) ? urlparameter.page : 1,
            levelcat: (urlparameter.levelcat) ? urlparameter.levelcat : '0',
            category: (urlparameter.category) ? urlparameter.category : '',
            category2: (urlparameter.category2) ? urlparameter.category2 : '',
            category3: (urlparameter.category3) ? urlparameter.category3 : ''
        })
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.location.search!==this.props.location.search) {
            const urlparameter = queryString.parse(nextProps.location.search)
            this.setState({
                keyword: (urlparameter.keyword) ? urlparameter.keyword : '',
                sort: (urlparameter.sort) ? urlparameter.sort : 'terkait',
                page: (urlparameter.page) ? urlparameter.page : 1,
                levelcat: (urlparameter.levelcat) ? urlparameter.levelcat : '0',
                category: (urlparameter.category) ? urlparameter.category : '',
                category2: (urlparameter.category2) ? urlparameter.category2 : '',
                category3: (urlparameter.category3) ? urlparameter.category3 : ''
            })
        }
    }

    async componentDidMount() {
        
        this.setState({
            preloader: true
        })

        // URL Paramaters
        const urlparameter = queryString.parse(this.props.location.search)

        this.setState({
            keyword: (urlparameter.keyword) ? urlparameter.keyword : '',
            sort: (urlparameter.sort) ? urlparameter.sort : 'terkait',
            page: (urlparameter.page) ? urlparameter.page : 1,
            levelcat: (urlparameter.levelcat) ? urlparameter.levelcat : '0',
            category: (urlparameter.category) ? urlparameter.category : '',
            category2: (urlparameter.category2) ? urlparameter.category2 : '',
            category3: (urlparameter.category3) ? urlparameter.category3 : ''
        }, async () => {
            if(""!==this.state.keyword) {
                await API.get("GetAutoCorrect.php?token="+this.state.token+"&keyword="+this.state.keyword)
                
                .then(response => {
                    this.setState({
                        correctkeyword: response.data['RECORD'],
                    })
                })
                .catch(error => {
                    this.setState({
                        correctkeyword: []
                    })
                })

                await API.get("GetRelatedTagList.php?token="+this.state.token+"&keyword="+this.state.keyword)
                .then(response => {
                    this.setState({
                        relatedtaglist: response.data['RECORD'],
                    })
                })
                .catch(error => {
                    this.setState({
                        relatedtaglist: []
                    })
                })
            } else {
                this.setState({
                    correctkeyword: [],
                    relatedtaglist: []
                })
            }
            
            await API.get('GetContentList.php?token='+this.state.token+'&keyword='+this.state.keyword+'&cat1='+this.state.category+'&cat2='+this.state.category2+'&cat3='+ReactHtmlParser(this.state.category3))
            .then(response => {
                this.props.fetchContentList(response.data['RECORD'])
                this.setState({
                    preloader: false
                })
            })
            .catch(error => {
                this.props.fetchContentList('')
                this.setState({
                    preloader: false
                })
            })
        })
        window.scrollTo(0, 0)
    }

    render() {
        const {
            componentDidMount,
            state: {
                keyword,
                sort,
                levelcat,
                category,
                category2,
                category3,
                page,
                correctkeyword,
                relatedtaglist,
                preloader
            }
        } = this

        const urlparamssortir = '/search?keyword='+keyword+'&category='+category+'&levelcat='+levelcat+'&category2='+category2
        const urlparamsidebar = '/search?keyword='+keyword+'&sort='+sort
        const urlparamsidebar2 = '/search?keyword='+keyword+'&sort='+sort+'&category='+category+'&levelcat=1'
        const urlparampagging = '/search?keyword='+keyword+'&sort='+sort+'&category='+category+'&levelcat='+levelcat+'&category2='+category2
        const urlparamcat1 = '/search?sort='+sort
        return (
            <div>
                <Preload show={preloader} />
                <GoTop scrollStepInPx="50" delayInMs="30" />
                <Header keyword={keyword} sort={sort} category={category} urlparamssortir={urlparamssortir} refresh={componentDidMount} {...this.props}/>
                <div className="body">
                    <Sidebar urlparamsidebar={urlparamsidebar} urlparamsidebar2={urlparamsidebar2} levelcat={levelcat} category={category} category2={category2} category3={category3} refresh={componentDidMount} {...this.props}/>
                    <Content 
                        keyword={keyword} 
                        sort={sort}
                        levelcat={levelcat}
                        category1={category}
                        category2={category2}
                        category3={category3}
                        activepage={page}
                        urlparampagging={urlparampagging} 
                        urlparamcat1={urlparamcat1}
                        refresh={componentDidMount}
                        correctkeyword={correctkeyword}
                        relatedtaglist={relatedtaglist}
                        {...this.props} />
                    
                </div>
                <Footer/>
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    fetchContentList: (contentlist) => dispatch({type:'ADD_CONTENTLIST', contentlist}),
})

export default connect(null,mapDispatchToProps)(Result)
